import mixpanel from 'mixpanel-browser';

import type { IAnalyticsService } from './analytics.types'

export class AnalyticsService implements IAnalyticsService {
  private isEnabled: boolean;

  constructor() {
    this.isEnabled = !!import.meta.env.VITE_MIXPANEL_TOKEN
  }

  reset(): void {
    if (this.isEnabled) {
      mixpanel.reset()
    }
  }

  identify(id: string): void {
    if (this.isEnabled) {
      mixpanel.identify(id)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(event: string, properties?: Record<string, any>): void {
    if (this.isEnabled) {
      mixpanel.track(event, properties)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  people_set(properties: Record<string, any>): void {
    if (this.isEnabled) {
      mixpanel.people.set(properties)
    }
  }
}

export const analyticsService = new AnalyticsService()
